// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3ea6fa5da8--icon--lW_K4","icon--small":"_3ea6fa5da8--icon--small--jOOca","icon--3":"_3ea6fa5da8--icon--3--vyJ8Q","icon--4":"_3ea6fa5da8--icon--4--o18Ir"};